import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./components/Home";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsOfConditions from "./components/TermsOfConditions";
import './styles.css';
import CancellationRefunds from "./components/CancellationRefunds";
import ShippingPolicy from "./components/ShippingPolicy";
import PaymentHistory from "./components/PaymentHistory";
import Help from "./components/Help";
import { Helmet } from "react-helmet";


function App() {


  return (
    <BrowserRouter>
    <Helmet>
    <title>AI for Google Sheets | ClevSheets AI</title>
    <meta 
      name="description" 
      content="Automate Google Sheets using AI. No formulas needed — just type what you want. ClevSheets AI cleans data, builds formulas, and fixes sheets instantly."
    />
    <meta 
      name="keywords" 
      content="AI for Google Sheets, Google Sheets automation tool, ChatGPT for Google Sheets, AI spreadsheet assistant, no formula AI tool, natural language spreadsheet commands, AI formulas generator, AI data cleaning for spreadsheets"
    />

    {/* OG Tags */}
    <meta property="og:title" content="ClevSheets AI — Google Sheets AI Automation" />
    <meta property="og:description" content="Automate formulas, clean data, and generate sheets using natural language AI." />
    <meta property="og:image" content="/og-image.png" />
    <meta property="og:url" content="https://clevsheetsai.com" />
    <meta property="og:type" content="website" />

    {/* Twitter */}
    {/* <meta name="twitter:card" content="summary_large_image" /> */}

    {/* JSON Schema */}
    <script type="application/ld+json">
      {`
      {
        "@context":"https://schema.org",
        "@type":"SoftwareApplication",
        "name":"ClevSheets AI",
        "applicationCategory":"BrowserExtension",
        "operatingSystem":"Chrome",
        "description":"AI for Google Sheets. Automate spreadsheets with natural language. No formulas needed.",
        "url":"https://clevsheetsai.com",
        "softwareVersion":"1.0",
        "offers":{"@type":"Offer","price":"0","priceCurrency":"USD"}
      }
      `}
    </script>
  </Helmet>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/cancellation-refunds" element={<CancellationRefunds />} />
        <Route path="/shipping-policy" element={<ShippingPolicy />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-conditions" element={<TermsOfConditions />} />
        <Route path="/payment-history" element={<PaymentHistory />} />
        <Route path="/help" element={<Help />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;